
import { HttpQueryFreeze, HttpSaveUnfreeze } from '@/service/recharge';
import TableList from "@components/templates/tablelist";
import comFreeze from "./freezealert"
import { mapState, mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    components: {
        comFreeze
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_status: null,
                    EQ_type:1,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            isSuper: this.$store.state.userinfo.isSuper
        };
    },
    methods: {
        ajaxRequest: HttpQueryFreeze,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'add':
                    this.operate = {
                        title: this.$t('fbb.freeze.query', { defaultValue: '资金冻结' }),
                        show: true,
                        width: 520,
                        component: "comFreeze",
                        showFooter: false,
                        params: { ids: params },
                    }
                    break;
                case 'unfreeze':
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: this.$t('fbb.freeze.cusunfreeze', { defaultValue: '账户解冻' }),
                        params: { ids: params },
                        ajaxRequest: HttpSaveUnfreeze
                    };
                    break
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/funding/freeze/export", this.formData,
                        "download"
                    );
                    break;
            }
        },
    },
    computed: {
        // ...mapGetters('dictionary', ['getSysorgList']),
        ...mapGetters('dictionary', ['getNextOrgList']),
        TabsData() {
            return [
                {
                    name: this.$t('fbb.bill.freeze_close', { defaultValue: '冻结' }),
                    key: 'EQ_status',
                    val: 0
                }, {
                    name: this.$t('fbb.bill.freeze_open', { defaultValue: '解冻' }),
                    key: 'EQ_status',
                    val: 1
                }, {
                    name: this.$t('fbb.alloment.all', { defaultValue: '所有' }),
                    key: 'EQ_status',
                    val: null
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('fbb.bill.freeze_open', { defaultValue: '解冻' }),
                    operate: "unfreeze",
                    theme: "success",
                    batch: true
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    theme: "info",
                },
            ]
        },

        SearchsData() {
            return [
                {
                    label: this.$t('global.common.organization', { defaultValue: '组织' }),
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show: true,
                    options: this.getNextOrgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.bill.freeze_close', { defaultValue: '冻结' })+this.$t('fbb.alloment.date', { defaultValue: '日期' }),
                    key: 'BT_freezeDate',
                    show: true,
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('fbb.bill.freeze_open', { defaultValue: '解冻' })+this.$t('fbb.alloment.date', { defaultValue: '日期' }),
                    key: 'BT_unfreezeDate',
                    show: true,
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('fbb.bill.account_org', { defaultValue: '账户组织' }),
                    key: 'organizationName',
                    sortable: true
                },
                {
                    title: this.$t('erp.b2c.money', { defaultValue: '金额' })+'(USD)',
                    key: 'amount',
                    sortable: true
                }, {
                    title: this.$t('fbb.bill.freeze_close', { defaultValue: '冻结' })+this.$t('global.common.reason', { defaultValue: '原因' }),
                    key: 'cause',
                    sortable: true
                }, {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'status',
                    render: (h, { row }) => {
                        return <div>{row.status == 0 ? this.$t('fbb.bill.freeze_close', { defaultValue: '冻结' }) : this.$t('fbb.bill.freeze_open', { defaultValue: '解冻' })}</div>
                    },
                    sortable: true
                }, {
                    title: this.$t('fbb.bill.freeze_close', { defaultValue: '冻结' })+this.$t('global.datepicker.time', { defaultValue: '时间' }),
                    key: 'freezeDate',
                    sortable: true
                }, {
                    title: this.$t('fbb.bill.freeze_open', { defaultValue: '解冻' })+this.$t('global.datepicker.time', { defaultValue: '时间' }),
                    key: 'unfreezeDate',

                }];
        },
    },
};




